import { Input } from '../Input'
import { InputWrapper, ErrorMessage } from '../../styles/global'

export function ValidatedInput({ name, errors, touched, onBlur, disabled, ...props }) {
  const isFieldValid = touched[name] && !errors[name]
  const isFieldInvalid = touched[name] && errors[name]

  return (
    <InputWrapper>
      <Input
        {...props}
        disabled={disabled}
        onBlur={() => onBlur(name)}
        style={{
          borderColor: isFieldInvalid ? '#ef4444' : isFieldValid ? '#10b981' : undefined,
          borderWidth: isFieldInvalid || isFieldValid ? '2px' : undefined,
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? 'not-allowed' : undefined,
          ...props.style,
        }}
      />
      {isFieldInvalid && <ErrorMessage>✗ {errors[name]}</ErrorMessage>}
    </InputWrapper>
  )
}
